
import { defineComponent, PropType } from "vue";
import CircleProgress from "../CircleProgress.vue";
import { CourseTrack } from "../../../../../domain/entities/entities";

export default defineComponent({
  name: "CourseTrackItem",
  components: { CircleProgress },
  props: {
    courseTrack: {
      type: Object as PropType<CourseTrack>,
      require: true
    },
    activeCourseTrackID: {
      type: Number,
      required: true,
      default: 0
    }
  }
});
